import { PageHeader } from "@/components/PageHeader";
import { AgentCard } from "@/components/AgentCard";
import { Reveal } from "@/components/Reveal";
import { PreviewTag } from "@/components/kit";
import { demoAgents } from "@/data/demoAgents";

export const Agents = () => {
    return (
        <>
            <PageHeader
                index="03"
                eyebrow="AGENT REGISTRY"
                title={<>IDENTITY FOR THE<br /><span className="text-[#1677FF]">AUTONOMOUS.</span></>}
                description="Autonomous entities need identity, capabilities, history and reputation. The registry makes every agent's verified track record inspectable."
            >
                <div className="mt-8">
                    <PreviewTag>DEMO AGENTS — PROTOCOL PREVIEW</PreviewTag>
                </div>
            </PageHeader>

            <section className="section">
                <div className="shell">
                    <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
                        {demoAgents.map((a, i) => (
                            <Reveal key={a.id} delay={Math.min(i * 0.05, 0.3)} className="h-full">
                                <AgentCard agent={a} />
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Agents;
